"use client";

import React from "react";
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Link } from "@/components/common/Link";
import {
  ShopBreadcrumbsProvider,
  useShopBreadcrumbs,
} from "@/integrations/wordpress/WordPressEcommerceShopBreadcrumbs";
import {
  EcommerceTermsProvider,
  useEcommerceTerms,
} from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";

declare const wvcClient: any;

function ArchiveHeaderConsumer() {
  const { links, loading: breadcrumbsLoading, error: breadcrumbsError } = useShopBreadcrumbs();
  
  const { loading: termsLoading } = useEcommerceTerms();

  
  let title = "Collection";
  if (!breadcrumbsLoading && links && links.length > 0) {
    title = links[links.length - 1].title;
  }

  const isLoading = breadcrumbsLoading || termsLoading;

  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center relative z-10">
      {}
      <div className="mb-6 flex justify-center">
        {isLoading ? (
          <div className="h-5 w-64 animate-pulse rounded-md bg-muted/30"></div>
        ) : breadcrumbsError || !links || links.length === 0 ? null : (
          <Breadcrumb>
            <BreadcrumbList className="justify-center">
              {links.map((link, i) => {
                const isLast = i === links.length - 1;
                return (
                  <React.Fragment key={link.href}>
                    <BreadcrumbItem data-index={i}>
                      {isLast ? (
                        <BreadcrumbPage className="text-primary font-medium tracking-wide">
                          {link.title}
                        </BreadcrumbPage>
                      ) : (
                        <BreadcrumbLink asChild>
                          <Link
                            to={link.href}
                            className="text-muted-foreground hover:text-foreground transition-colors uppercase text-xs tracking-wider font-semibold"
                          >
                            {link.title}
                          </Link>
                        </BreadcrumbLink>
                      )}
                    </BreadcrumbItem>
                    {!isLast && <BreadcrumbSeparator className="text-muted-foreground/50" />}
                  </React.Fragment>
                );
              })}
            </BreadcrumbList>
          </Breadcrumb>
        )}
      </div>

      {}
      <h1 className="font-default text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight text-foreground uppercase drop-shadow-sm">
        {isLoading ? (
          <div className="h-14 w-80 animate-pulse rounded-lg bg-muted/30 mx-auto mt-2"></div>
        ) : (
          title
        )}
      </h1>
      
      {}
      <div className="mt-8 h-px w-24 bg-gradient-to-r from-transparent via-primary/50 to-transparent mx-auto"></div>
    </div>
  );
}

export default function ArchiveTitle() {
  
  const current_wp_term_query_params =
    typeof wvcClient !== "undefined"
      ? wvcClient.getCurrentWPTermQueryParams()
      : { taxonomy: "product_cat" };
  const wp_term_query = new WP_Term_Query(current_wp_term_query_params);

  return (
    <section
      id="archive-title"
      className="dark bg-background text-foreground relative py-16 md:py-24 lg:py-32 overflow-hidden border-b border-border/10"
    >
      {}
      <div className="absolute inset-0 pointer-events-none overflow-hidden flex items-center justify-center">
        <div className="w-[800px] h-[400px] bg-primary/5 blur-[120px] rounded-full opacity-70 transform -translate-y-1/4"></div>
      </div>

      <EcommerceTermsProvider wp_term_query={wp_term_query}>
        <ShopBreadcrumbsProvider>
          <ArchiveHeaderConsumer />
        </ShopBreadcrumbsProvider>
      </EcommerceTermsProvider>
    </section>
  );
}